import React, { useState, useEffect, useCallback } from 'react'
import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'
import {config} from '../../../config'
import { useNavigate, Link } from 'react-router-dom'
import axios from 'axios'
import { Pagination, Typography } from '@mui/material'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Testimonials = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [testmonials, setTestimonials] = useState([])
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  })
  const [totalResult, setTotalResult] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  const navigate = useNavigate()

  // Get testimonials
  const getTestimonials = useCallback(() => {
    let url = config.apiurl + '/testlist/get_test'

    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setTestimonials(res?.data?.data?.results)
        setTotalResult(res?.data?.data?.totalHits)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"})

    axios.get(url, { params }).then(onSuccess, onFailure)
  }, [params])
  useEffect(() => {
    getTestimonials()
  }, [getTestimonials, params])

  const deleteOptionList = async (id) => {
    let deletecat = await fetch(config.apiurl + '/testlist/' + id, {
      method: 'Delete',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    deletecat = await deletecat.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    if (deletecat) {
      getTestimonials()
    }
  }

  // Handle pagination
  const handlePagination = (event, value) => {
    if (typeof value === 'number') {
      setCurrentPage(value)
      setParams((prevState) => ({ ...prevState, page: value }))
      // setPageQuery({ ...pageQuery, page: value })
    }
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Testimonials</h6>
                    </div>
                    <div className="col-6 text-end">
                      <Link
                        className="btn bg-gradient-dark mb-0"
                        to="/testimonial/add"
                      >
                        <i className="fas fa-plus" aria-hidden="true"></i>
                        &nbsp;&nbsp;Add Testimonial
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="card-body px-0 pt-0 pb-2">
                  <div className="table-responsive p-3">
                    <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-secondary opacity-7 ps-2">
                            S.No
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Name
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Image
                          </th>
                          {/* <th className="text-secondary opacity-7 ps-2">
                            Content
                          </th> */}
                          <th className="text-secondary opacity-7">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {testmonials &&
                          testmonials.length &&
                          testmonials.map((item, index) => (
                            <tr key={item._id}>
                              <td>
                                {currentPage > 1
                                  ? `${
                                      index + 1 === 10
                                        ? currentPage
                                        : currentPage - 1
                                    }${index + 1 === 10 ? 0 : index + 1}`
                                  : index + 1}
                              </td>
                              <td>
                                <div className="d-flex flex-column justify-content-center">
                                  <h6 className="mb-0 text-sm">{item.name}</h6>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div>
                                    <img
                                      src={
                                        config.fileurl + item.image ||
                                        '/img/error.png'
                                      }
                                      className="avatar avatar-sm me-3"
                                      alt={item.name}
                                    />
                                  </div>
                                </div>
                              </td>
                              {/* <td>
                                <div className="d-flex flex-column justify-content-center">
                                  <textarea>{item.content}</textarea>
                                </div>
                              </td> */}

                              <td>
                                <Link
                                  to={'/testimonial/edit/' + item._id}
                                  className="btn btn-link text-dark px-3 mb-0"
                                >
                                  <i
                                    className="fas fa-pencil-alt text-dark me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Edit
                                </Link>
                                <a
                                  className="btn btn-link text-danger text-gradient px-3 mb-0"
                                  onClick={() => deleteOptionList(item._id)}
                                >
                                  <i
                                    className="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Delete
                                </a>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-12 paginationWrapper">
                  {/* Pagination */}
                  {totalResult < 11 ? (
                    <></>
                  ) : (
                    <section className={'paginationWrapper'}>
                      <section>
                        <Typography variant="body1">
                          Page {currentPage} of{' '}
                          {Math.ceil(totalResult / params.limit)}
                        </Typography>
                      </section>
                      <Pagination
                        count={Math.ceil(totalResult / params.limit)}
                        page={currentPage}
                        onChange={handlePagination}
                        color="primary"
                        shape="rounded"
                      />
                    </section>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </main>
    </>
  )
}

export default Testimonials
